// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__26uOa","insightsList":"newBusinessInsightsMenu_insightsList__33UeK","active":"newBusinessInsightsMenu_active__pnWew"};